// components/TodaysSubmissions.jsx - Display Today's Submissions for this Job
import React from 'react'
import { FileText, Clock } from 'lucide-react'

export default function TodaysSubmissions({ submissions }) {
  if (!submissions || submissions.length === 0) {
    return null
  }
  
  return (
    <div className="card">
      <h4 className="text-sm font-medium text-gray-700 flex items-center gap-2">
        <FileText className="w-4 h-4" />
        Previous Records Today ({submissions.length})
      </h4>
      
      <div className="mt-3 space-y-2">
        {submissions.map((submission, index) => (
          <div 
            key={index}
            className="p-3 bg-gray-50 rounded-lg text-sm"
          >
            <div className="flex items-start justify-between">
              <div>
                <div className="font-medium text-gray-900">
                  {submission.productName}
                </div>
                <div className="text-gray-500 text-xs mt-0.5">
                  {submission.applicationMethod} • {submission.productAmount} {submission.productUnit}
                </div>
              </div>
              <div className="flex items-center gap-1 text-gray-400 text-xs">
                <Clock className="w-3 h-3" />
                {submission.time}
              </div>
            </div>
            
            {submission.areaOrPlantTreated && (
              <div className="mt-1 text-xs text-gray-500">
                Area: {submission.areaOrPlantTreated}
              </div>
            )}
          </div>
        ))}
      </div>
      
      <p className="mt-3 text-xs text-gray-500">
        Multiple applications can be recorded for the same job
      </p>
    </div>
  )
}
